import label from "@/lang/StaticLabels.js";

// PSLRY Navbar  -----------------------------------------------
let navItems = [
  {
    title: label.modules.parak,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PSLRYDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PSLRYTaxTable",
        label: label.menu.taxTable,
        metaLabel: label.page.taxTable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYBenefitsAndDeductionList",
        label: label.menu.benefitsAndDeduction,
        metaLabel: label.page.benefitsAndDeduction,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYWorkingHours",
        label: label.menu.workingHours,
        metaLabel: label.page.workingHours,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYSampleExcelFiles",
        label: label.menu.sampleExcelFiles,
        metaLabel: label.page.sampleExcelFiles,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
  
      // {
      //   to: "PSLRYSettingTransactions",
      //   label: label.menu.settingTransactions,
      //   metaLabel: label.page.settingTransactions,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: false,
      //   subItems: [],
      // },
      {
        to: "PSLRYJobGroup",
        label: label.menu.jobGroup,
        metaLabel: label.page.jobGroup,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYPersonnelList",
        label: label.menu.personnel,
        metaLabel: label.page.personnel,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYInsuranceType",
        label: label.menu.insuranceType,
        metaLabel: label.page.insuranceType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYInsuranceStudio",
        label: label.menu.insuranceStudio,
        metaLabel: label.page.insuranceStudio,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYEmploymentType",
        label: label.menu.employmentType,
        metaLabel: label.page.employmentType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYAgreementRow",
        label: label.menu.agreementRow,
        metaLabel: label.page.agreementRow,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYStudyFieldType",
        label: label.menu.studyFieldType,
        metaLabel: label.page.studyFieldType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYDegree",
        label: label.menu.degree,
        metaLabel: label.page.degree,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYDepartment",
        label: label.menu.department,
        metaLabel: label.page.department,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },

      {
        to: "PSLRYFormula",
        label: label.menu.formulas,
        metaLabel: label.page.formulas,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYContractType",
        label: label.menu.contractType,
        metaLabel: label.page.contractType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYAdditionalContractParameter",
        label: label.menu.additionalContractParameter,
        metaLabel: label.page.additionalContractParameter,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYTaxRateType",
        label: label.menu.taxRateType,
        metaLabel: label.page.taxRateType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYBankExportTemplateList",
        label: label.menu.bankExportTemplate,
        metaLabel: label.page.bankExportTemplate,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYPayslipSystemControl",
        label: label.menu.payslipSystemControl,
        metaLabel: label.page.payslipSystemControl,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYSetting",
        label: label.menu.settings,
        metaLabel: label.page.slrySetting,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.contract,
        metaLabel: label.page.contract,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSLRYContractSampleList",
            label: label.menu.contractSample,
            metaLabel: label.page.contractSample,
            icon: "mdi-circle-small",
          },
          {
            to: "PSLRYContractList",
            label: label.menu.contractsList,
            metaLabel: label.page.contractsList,
            icon: "mdi-circle-small",
          },
          {
            to: "PSLRYEditGroupContract",
            label: label.menu.editGroupContract,
            metaLabel: label.page.editGroupContract,
            icon: "mdi-circle-small",
          },
        ],
      },

      {
        to: "PSLRYPayrollEmployeeList",
        label: label.menu.payrollEmployee,
        metaLabel: label.page.payrollEmployee,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYInsuranceEmployeeList",
        label: label.menu.insuranceEmployee,
        metaLabel: label.page.insuranceEmployee,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYTaxEmployeeList",
        label: label.menu.taxEmployee,
        metaLabel: label.page.taxEmployee,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: null,
        label: label.menu.leave,
        metaLabel: label.page.leave,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSLRYLeaveList",
            label: label.menu.leaveList,
            metaLabel: label.page.leaveList,
            icon: "mdi-circle-small",
          },
          {
            to: "PSLRYLeaveConfirm",
            label: label.menu.leaveConfirm,
            metaLabel: label.page.leaveConfirm,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.mission,
        metaLabel: label.page.mission,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSLRYMissionList",
            label: label.menu.missionList,
            metaLabel: label.page.missionList,
            icon: "mdi-circle-small",
          },
          {
            to: "PSLRYMissionConfirm",
            label: label.menu.missionConfirm,
            metaLabel: label.page.missionConfirm,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.advance,
        metaLabel: label.page.advance,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSLRYAdvanceList",
            label: label.menu.advancesList,
            metaLabel: label.page.advancesList,
            icon: "mdi-circle-small",
          },
          {
            to: "PSLRYAddGroupAdvance",
            label: label.menu.addGroupAdvance,
            metaLabel: label.page.addGroupAdvance,
            icon: "mdi-circle-small",
          },
          {
            to: "PSLRYAdvanceConfirm",
            label: label.menu.advanceConfirm,
            metaLabel: label.page.advanceConfirm,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.bankExport,
        metaLabel: label.page.bankExport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSLRYBankExport",
            label: label.menu.bankExport,
            metaLabel: label.page.bankExport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSLRYBankExportHistory",
            label: label.menu.bankExportHistory,
            metaLabel: label.page.bankExportHistory,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.managementCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSLRYAdvanceManagementCartable",
            label: label.menu.advanceManagementCartable,
            metaLabel: label.page.advanceManagementCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PSLRYLeaveManagementCartable",
            label: label.menu.leaveManagementCartable,
            metaLabel: label.page.leaveManagementCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PSLRYMissionManagementCartable",
            label: label.menu.missionManagementCartable,
            metaLabel: label.page.missionManagementCartable,
            icon: "mdi-circle-small",
          },
        ],
      },
    ],
  },
  {
    to: null,
    label: label.menu.reports,
    icon: "mdi-chart-bar-stacked",
    active: false,
    subItems: [
      {
        to: "PSLRYSalaryAndBenefitsReport",
        label: label.menu.salaryAndBenefitsReport,
        metaLabel: label.page.salaryAndBenefitsReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYEmployeePayrollSummaryPersonnelReport",
        label: label.menu.employeePayrollSummaryPersonnelReport,
        metaLabel: label.page.employeePayrollSummaryPersonnelReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYPayrollEmployeeSummaryReport",
        label: label.menu.payrollEmployeeSummary,
        metaLabel: label.page.payrollEmployeeSummary,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYAdvanceReport",
        label: label.menu.advanceReport,
        metaLabel: label.page.advanceReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSLRYPayslipReport",
        label: label.menu.payslipReport,
        metaLabel: label.page.payslipReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
